import { ReactNode } from 'react';
import { ActionContainer } from './styles';

interface ActionProps {
  icon: ReactNode;
  children: ReactNode;
  color: string;
  onClick?: any;
}
export const Action = ({ icon, children, color, onClick }: ActionProps) => {
  return (
    <ActionContainer color={color} onClick={onClick}>
      {icon}
      {children}
    </ActionContainer>
  );
};
